import React, { useEffect, useRef, useState } from 'react';
import './NewCategoria.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import Swal from 'sweetalert2';
import { fetchUsuario, getUsuario } from '../../user';
import planes from '../../planes';

export default function NewCategoria({ onCreated }) {
    const [mensaje, setMensaje] = useState('');
    const [categoria, setCategoria] = useState('');
    const [imagen, setImagen] = useState(null);
    const [imagenPreview, setImagenPreview] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const previewUrlRef = useRef('');

    const revokePreview = () => {
        if (previewUrlRef.current) {
            URL.revokeObjectURL(previewUrlRef.current);
            previewUrlRef.current = '';
        }
    };

    const resetForm = () => {
        revokePreview();
        setCategoria('');
        setImagen(null);
        setImagenPreview('');
        setMensaje('');
    };

    const abrirModal = () => {
        resetForm();
        setModalOpen(true);
    };

    const cerrarModal = () => {
        resetForm();
        setModalOpen(false);
    };

    useEffect(() => () => {
        revokePreview();
    }, []);

    const handleImagenChange = (event) => {
        const selectedImage = event.target.files?.[0] || null;
        revokePreview();
        setImagen(selectedImage);

        if (selectedImage) {
            const previewUrl = URL.createObjectURL(selectedImage);
            previewUrlRef.current = previewUrl;
            setImagenPreview(previewUrl);
        } else {
            setImagenPreview('');
        }
    };

    const crear = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('categoria', categoria.trim());
        if (imagen) {
            formData.append('imagen', imagen);
        }

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/categoriasPost.php`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                cargarCategoria();
                onCreated?.();
                cerrarModal();
            } else {
                setMensaje('');
                toast.error(data.error || 'No se pudo crear la categoría.');
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);
    const usuarioLegued = getUsuario();

    const plan = planes[0]?.plan;
    const limitePlan = planes[0]?.limiteCategoria;
    const mensagePlan = `¡Alcanzaste el límite del plan ${plan}! <br/>Tu límite son ${limitePlan} categorias`;
    const [categorias, setCategorias] = useState([]);
    const alertPlan = () => {
        cargarCategoria();
        Swal.fire(
            '¡Error!',
            mensagePlan,
            'error'
        );
    };

    useEffect(() => {
        cargarCategoria();
    }, []);

    const cargarCategoria = () => fetch(`${baseURL}/categoriasGet.php`, {
        method: 'GET',
    })
        .then(response => response.json())
        .then(data => {
            setCategorias(data.categorias || []);
        })
        .catch(error => console.error('Error al cargar categorías:', error));

    const canCreate = (
        !usuarioLegued?.idUsuario
        || usuarioLegued?.rol === 'admin'
        || usuarioLegued?.rol === 'colaborador'
    );
    const reachedPlanLimit = categorias?.length >= limitePlan;

    return (
        <div className='NewContain'>
            <ToastContainer />
            {!loading && canCreate && (
                <button
                    onClick={reachedPlanLimit ? alertPlan : abrirModal}
                    className='btnSave'
                >
                    <span>+</span> Agregar
                </button>
            )}
            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button type='button' className='selected'>Agregar Categoria</button>
                            <button
                                type='button'
                                className='close categoryModalClose'
                                onClick={cerrarModal}
                                aria-label='Cerrar creación de categoría'
                            >
                                &times;
                            </button>
                        </div>
                        <form id='crearCategoriaForm' onSubmit={crear}>
                            <fieldset>
                                <legend>Categoría</legend>
                                <input
                                    type='text'
                                    name='categoria'
                                    value={categoria}
                                    onChange={(event) => setCategoria(event.target.value)}
                                    required
                                />
                            </fieldset>
                            <fieldset className='categoryImageField'>
                                <legend>Imagen (opcional)</legend>
                                <input
                                    id='nuevaCategoriaImagen'
                                    type='file'
                                    name='imagen'
                                    accept='image/jpeg,image/png'
                                    onChange={handleImagenChange}
                                />
                                {imagenPreview ? (
                                    <img
                                        className='categoryImagePreview'
                                        src={imagenPreview}
                                        alt='Vista previa de la categoría'
                                    />
                                ) : (
                                    <p className='categoryImageHint'>JPG o PNG. Se guardará como WebP.</p>
                                )}
                            </fieldset>
                            <button
                                type='submit'
                                className={mensaje ? 'btnLoading' : 'btnPost'}
                                disabled={Boolean(mensaje)}
                            >
                                {mensaje || 'Agregar'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
